<template>
    <div class="dia_container" v-loading="loading" element-loading-text="加载中！">
        <div class="steps-header-container">
            <el-steps center align-center :active="active">
                <el-step title="配置数据库"></el-step>
                <el-step title="初始化租户"></el-step>
            </el-steps>
        </div>
        <div class="steps-content-container">
            <div v-if="active === 1" class="database_set">
                <div class="form_line cl">
                    <label class="l">只读：</label>
                    <div class="l textarea_full"><el-input type="textarea" v-model="url1"></el-input></div>
                </div>
                <div class="form_line cl">
                    <label class="l">读写：</label>
                    <div class="l textarea_full"><el-input type="textarea" v-model="url2"></el-input></div>
                </div>
                <div class="form_line cl">
                    <label class="l">报表：</label>
                    <div class="l textarea_full"><el-input type="textarea" v-model="url3"></el-input></div>
                </div>
            </div>
            <div v-if="active === 2" class="status-caption">
                <p>请点击【开户】进行租户初始化</p>
            </div>
        </div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button v-if="active === 1" type="primary" @click="saveDatabaseSet">配置数据库</el-button>
            <el-button v-if="active === 2" type="primary" @click="openAccount">开户</el-button>
        </div>
    </div>
</template>
<script>
    import { errorMessage } from '../../../util'
    export default {
        props: ['param'],
        data(){
            return {
                active: 1,
                url1: '',  // 只读
                url2: '',  // 读写
                url3: '',   // 报表
                loading: false
            }
        },
        created(){
            this.init()
        },
        methods: {
            init() {
                this.loading = true
                this.$http.post(`/platserv/tenantDb/list`, {
                    tenantcode: this.param.tenantCode
                }).then(res => {
                    if(res.data.resp_data && res.data.resp_data.length > 0){
                        this.active = 2
                    } else {
                        this.active = 1
                    }
                    this.url1 = this.url2 = this.url3 = ''
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                    errorMessage(error, this)
                })
            },
            // 保存配置数据库
            saveDatabaseSet(key) {
                let param = {
                    tenantcode: this.param.tenantCode,
                    productcode: this.param.productCode,
                    dbs: [{
                        tenantdbtype: 1,
                        tenantdbname: '只读',
                        connstr: this.url1
                    },{
                        tenantdbtype: 2,
                        tenantdbname: '读写',
                        connstr: this.url2
                    },{
                        tenantdbtype: 3,
                        tenantdbname: '报表',
                        connstr: this.url3
                    }]
                }
                let checkResult = ''
                if(!param.dbs[0].connstr){
                    checkResult = '请填写只读数据库地址！'
                } else if(!param.dbs[1].connstr){
                    checkResult = '请填写读写数据库地址！'
                } else if(!param.dbs[2].connstr){
                    checkResult = '请填写报表数据库地址！'
                }
                if(checkResult){
                    this.$message.warning(checkResult)
                    return
                }
                this.$http.post(`/platserv/tenantDb/updateDbConnstr`,param).then(res => {
                    this.active = 2
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            // 开户
            openAccount(){
                let param = {
                    tenantcode: this.param.tenantCode,
                    productcode: this.param.productCode,
                    productversioncode: this.param.productVersionCode
                }
                this.$http.post(`/platserv/tenant/init`,param).then(res => {
                    this.$message.success('开户成功！')
                    this.$emit('reload')
                    this.cancel()
                }).catch(error => {
                    errorMessage(error, this)
                })
            },
            cancel() {
                this.$emit('cancel')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// OpenAccount.vue?bf5aa158